import React from 'react';
import Loadable from 'react-loadable';

import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';

let Component = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  Component = require('./innovation_by_design_page_2018').default;
}

export function ibd2018Page(store) {
  const routeConfig = {
    path: '/innovation-by-design/2018',
    component() {
      if (Component) {
        return <Component />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk() {
      return import(/* webpackChunkName: "ibdPage" */ './innovation_by_design_page_2018').then(
        resp => {
          Component = resp.default;
          routeConfig.loadData = Component.loadData(store);
          return Component;
        }
      );
    },
    chunk: 'ibdPage',
    autoScrollOff: true
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}

let LegacyComponent = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  LegacyComponent = require('./innovation_by_design_page').default;
}

export function legacyIbdPage(store) {
  const routeConfig = {
    path: '/innovation-by-design/:year',
    component() {
      if (LegacyComponent) {
        return <LegacyComponent />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    loadData: LegacyComponent ? LegacyComponent.loadData(store) : false,
    preloadChunk() {
      return import(/* webpackChunkName: "legacyIbdPage" */ './innovation_by_design_page').then(
        resp => {
          LegacyComponent = resp.default;
          routeConfig.loadData = LegacyComponent.loadData(store);
          return LegacyComponent;
        }
      );
    },
    chunk: 'legacyIbdPage',
    autoScrollOff: true
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}
